import { render, staticRenderFns } from "./List.vue?vue&type=template&id=5a1ae8f6&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a1ae8f6')) {
      api.createRecord('5a1ae8f6', component.options)
    } else {
      api.reload('5a1ae8f6', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=5a1ae8f6&", function () {
      api.rerender('5a1ae8f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ispforum/forum/List.vue"
export default component.exports